/* Cerebra cart drawer — AJAX add-to-cart, slide-out cart, bundle upsell */
(function () {
  'use strict';

  var drawer, itemsEl, upsellEl, emptyEl, countEl, subtotalEl, savingsEl, checkoutEl, toastEl;
  var cfg = {};
  var cart = null;
  var busy = false;

  function money(cents, currency) {
    var n = (cents / 100).toFixed(2);
    var cur = currency || (cart && cart.currency) || 'USD';
    if (cur === 'USD' || cur === 'CAD' || cur === 'AUD') return '$' + n;
    if (cur === 'EUR') return '€' + n;
    if (cur === 'GBP') return '£' + n;
    return n + ' ' + cur;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function imgUrl(src, w) {
    if (!src) return '';
    return src.replace(/(\.[a-z]{3,4})(\?.*)?$/i, '_' + w + 'x' + w + '$1$2');
  }

  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2200);
  }

  /* ---------- Cart API ---------- */
  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; return c; });
  }

  function changeLine(line, qty) {
    setLoading(true);
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; render(); setLoading(false); return c; })
      .catch(function () { setLoading(false); toast('Something went wrong — please try again'); });
  }

  function addItem(body) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      body: body
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Could not add to cart'); });
      return r.json();
    });
  }

  /* ---------- Rendering ---------- */
  function setLoading(on) {
    busy = on;
    if (drawer) drawer.classList.toggle('is-loading', !!on);
  }

  function updateCount(n) {
    var el = document.getElementById('cartCount');
    if (el) el.textContent = n;
    if (countEl) countEl.textContent = n;
    try { localStorage.setItem('cerebra_cart', String(n)); } catch (e) {}
  }

  function planLabel(item) {
    if (item.selling_plan_allocation) {
      return '<p class="cd-item__plan cd-item__plan--sub">↻ Subscription · ships every 30 days · cancel anytime</p>';
    }
    if (item.quantity >= cfg.bundleQty) {
      return '<p class="cd-item__plan cd-item__plan--sub">★ 3-Month Bundle · 55% off applied</p>';
    }
    return '<p class="cd-item__plan">One-time purchase · 30-day supply</p>';
  }

  function renderItems() {
    var html = '';
    cart.items.forEach(function (item, i) {
      var line = i + 1;
      var hasDiscount = item.original_line_price > item.final_line_price;
      html +=
        '<div class="cd-item" data-line="' + line + '">' +
          '<a href="' + esc(item.url) + '"><img class="cd-item__img" src="' + esc(imgUrl(item.image, 160)) + '" alt="' + esc(item.product_title) + '" loading="lazy"></a>' +
          '<div>' +
            '<p class="cd-item__title">' + esc(item.product_title) + '</p>' +
            planLabel(item) +
            '<div class="cd-item__row">' +
              '<div class="cd-qty">' +
                '<button type="button" data-cd-qty="' + (item.quantity - 1) + '" data-line="' + line + '" aria-label="Decrease quantity">−</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-cd-qty="' + (item.quantity + 1) + '" data-line="' + line + '" aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<div class="cd-item__price">' +
                (hasDiscount ? '<s>' + money(item.original_line_price) + '</s>' : '') +
                money(item.final_line_price) +
              '</div>' +
            '</div>' +
            '<button type="button" class="cd-item__remove" data-cd-qty="0" data-line="' + line + '">Remove</button>' +
          '</div>' +
        '</div>';
    });
    itemsEl.innerHTML = html;
  }

  function renderUpsell() {
    var oneTime = null, oneTimeLine = 0, subCount = 0;
    cart.items.forEach(function (item, i) {
      if (item.selling_plan_allocation) { subCount++; return; }
      if (!oneTime && String(item.variant_id) === String(cfg.variantId)) { oneTime = item; oneTimeLine = i + 1; }
    });

    if (oneTime && oneTime.quantity < cfg.bundleQty) {
      var bundleSavings = cfg.singlePrice * cfg.bundleQty - cfg.bundlePrice;
      var perBottle = Math.round(cfg.bundlePrice / cfg.bundleQty);
      upsellEl.innerHTML =
        '<div class="cd-upsell">' +
          '<p class="cd-upsell__eyebrow">Most customers upgrade</p>' +
          '<p class="cd-upsell__title">Upgrade to the 3-Month Bundle</p>' +
          '<p class="cd-upsell__sub">3 bottles for <strong>' + money(cfg.bundlePrice) + '</strong> — that\'s ' + money(perBottle) + ' per bottle and <strong>' + money(bundleSavings) + ' extra savings</strong>. Results build over 4+ weeks, so most people stock up.</p>' +
          '<button type="button" class="cd-upsell__btn" data-cd-upgrade="' + oneTimeLine + '">Upgrade &amp; Save 55% →</button>' +
        '</div>';
      return;
    }
    if (oneTime && oneTime.quantity >= cfg.bundleQty) {
      upsellEl.innerHTML = '<div class="cd-unlocked"><span>🎉</span><span>Bundle unlocked — 55% off applied to your order.</span></div>';
      return;
    }
    if (subCount > 0) {
      upsellEl.innerHTML =
        '<div class="cd-perks"><strong>Subscriber perks locked in</strong>50% off every delivery · Free shipping always · Pause or cancel anytime · Priority support</div>';
      return;
    }
    upsellEl.innerHTML = '';
  }

  function render() {
    if (!cart) return;
    var empty = !cart.items || cart.items.length === 0;
    drawer.classList.toggle('is-empty', empty);
    emptyEl.hidden = !empty;
    updateCount(cart.item_count || 0);
    if (empty) {
      itemsEl.innerHTML = '';
      upsellEl.innerHTML = '';
      return;
    }
    renderItems();
    renderUpsell();
    subtotalEl.textContent = money(cart.total_price);
    var saved = (cart.original_total_price || cart.total_price) - cart.total_price;
    if (saved > 0) {
      savingsEl.hidden = false;
      savingsEl.textContent = 'You\'re saving ' + money(saved) + ' on this order';
    } else {
      savingsEl.hidden = true;
    }
  }

  /* ---------- Open / close ---------- */
  function open() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
  }

  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
  }

  function openWithCart() {
    setLoading(true);
    open();
    getCart().then(function () { render(); setLoading(false); }).catch(function () { setLoading(false); });
  }

  /* ---------- Wiring ---------- */
  function init() {
    drawer = document.getElementById('cartDrawer');
    if (!drawer) return;
    itemsEl = document.getElementById('cdItems');
    upsellEl = document.getElementById('cdUpsell');
    emptyEl = document.getElementById('cdEmpty');
    countEl = document.getElementById('cdCount');
    subtotalEl = document.getElementById('cdSubtotal');
    savingsEl = document.getElementById('cdSavings');
    checkoutEl = document.getElementById('cdCheckout');
    toastEl = document.getElementById('cdToast');

    cfg = {
      variantId: drawer.getAttribute('data-variant-id'),
      singlePrice: parseInt(drawer.getAttribute('data-single-price'), 10) || 5199,
      bundlePrice: parseInt(drawer.getAttribute('data-bundle-price'), 10) || 10799,
      bundleQty: parseInt(drawer.getAttribute('data-bundle-qty'), 10) || 3
    };

    // Close triggers
    drawer.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-cd-close]')) { close(); return; }
      var qtyBtn = t.closest('[data-cd-qty]');
      if (qtyBtn && !busy) {
        changeLine(parseInt(qtyBtn.getAttribute('data-line'), 10), parseInt(qtyBtn.getAttribute('data-cd-qty'), 10));
        return;
      }
      var up = t.closest('[data-cd-upgrade]');
      if (up && !busy) {
        up.disabled = true;
        up.textContent = 'Upgrading...';
        changeLine(parseInt(up.getAttribute('data-cd-upgrade'), 10), cfg.bundleQty).then(function () { toast('Bundle unlocked — 55% off applied'); });
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    // Cart icon opens drawer instead of navigating (unless already on cart page)
    if (!document.body.classList.contains('template-cart')) {
      document.querySelectorAll('a[href="/cart"], a.nav__cart').forEach(function (a) {
        if (a.closest('#cartDrawer')) return;
        a.addEventListener('click', function (e) {
          e.preventDefault();
          openWithCart();
        });
      });
    }

    // Intercept product add-to-cart forms
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        var label = btn ? btn.innerHTML : '';
        if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
        var fd = new FormData(form);
        if (!fd.get('selling_plan')) fd.delete('selling_plan');
        addItem(fd)
          .then(function () { return getCart(); })
          .then(function () {
            render();
            open();
            if (btn) { btn.disabled = false; btn.innerHTML = '✓ Added — View Cart'; setTimeout(function () { btn.innerHTML = label; }, 2500); }
          })
          .catch(function (err) {
            if (btn) { btn.disabled = false; btn.innerHTML = label; }
            toast(err && err.message ? err.message : 'Could not add to cart');
          });
      });
    });

    // Checkout button: show busy state
    if (checkoutEl) checkoutEl.addEventListener('click', function () { checkoutEl.classList.add('is-busy'); checkoutEl.textContent = 'Loading secure checkout...'; });

    // Real cart count on load (replaces localStorage count)
    getCart().then(function (c) { updateCount(c.item_count || 0); }).catch(function () {});

    // Open drawer automatically if redirected back with ?cart=open
    if (/[?&]cart=open/.test(location.search)) openWithCart();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.CerebraCart = { open: openWithCart, close: close, refresh: function () { return getCart().then(render); } };
})();
